import {connect} from "react-redux";
import MarkRegularization from "./MarkRegularization";
import {bindActionCreators} from "redux";
import { documentUploadUrlPublic } from "../../service/fileUpload/action";
import { saveRegularization } from "../../service/DarwinAttendance/action";

const mapStateToProps = (state) => ({
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
    insertRegularization: state.DarwinAttendanceSync.insertRegularization
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            documentUploadUrlPublic,
            saveRegularization
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(MarkRegularization);
